import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './SummarySection.scss';

const SummarySection = ({
  children,
  className,
  ...props
}) => (
  <section className={cx('SummarySection', className)} {...props}>
    {children}
  </section>
);

SummarySection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string
    ),
  ]),
};

SummarySection.defaultProps = {
  children: null,
  className: undefined,
};

export default SummarySection;
